import { render, staticRenderFns } from "./DataDescriptionC.vue?vue&type=template&id=2e76c01c&"
import script from "./DataDescriptionC.vue?vue&type=script&lang=js&"
export * from "./DataDescriptionC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports